/* eslint-disable react/no-array-index-key */
import * as React from "react";
import { Row, Col, Button, Form, Input, DatePicker } from "antd";
import { useState } from "react";
import moment from "moment";
import { useParams } from "react-router-dom";
import "./AccountInfo.less";
import ModalWindow from "../ModalWindow/ModalWindow";
import { displayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import OrganizationAccountInfo from "../accountsOrganization/OrganizationAccountInfo";
import IndividualAccountInfo from "../accountsIndividual/IndividualAccountInfo";
import { useAccountContainerContext } from "../../containers/AccountContainer/AccountContainerContext";
import featuresToggle from "../../lib/utils/featuresToggle";
import { hasLocalAccess } from "../../lib/configs";

export default function AccountInfo({ routeProps }) {
  const {
    fetchSubscriberVersions,
    handleCreateSubscriberVersion,
    handleCreateSubscriberVersionLoading,
    handleCloseSubscriberVersion,
    fetchAccountSubscribers,
    fetchEmailVersions,
    handleCreateEmailVersion,
    handleCloseEmailVersion,
    getAccount,
    changeOrganizationVersion,
    closeOrganizationVersion,
    closeAccountVersion,
    changeAccountVersion,
    changeAddressVersion,
    closeAddressVersion,
    getPropertyVersions,
    createExiteId,
    createEmail,
    getAccountOrganizationVersions,
    getAccountVersions,
    fetchAddressVersions,
    // checkExiteId,
    // startReprocess,
    // checkAndStartReprocess,
  } = routeProps;
  const { accountId } = useParams();
  const [isExiteIdModalOpened, setIsExiteIdModalOpened] = useState(false);
  const [isEmailModalOpened, setIsEmailModalOpened] = useState(false);
  const accountContainerContext = useAccountContainerContext();
  const [exiteIdForm] = Form.useForm();
  const [emailForm] = Form.useForm();

  const changeExiteIdOpenedModal = () => {
    setIsExiteIdModalOpened((prevState) => {
      if (prevState === false) exiteIdForm.resetFields();
      return !prevState;
    });
  };

  const changeEmailOpenedModal = () => {
    setIsEmailModalOpened((prevState) => !prevState);
    emailForm.resetFields();
  };

  const isAccountsIndividualAvailable = featuresToggle({
    value: true,
    alternativeValue: false,
    condition: hasLocalAccess("feature.accounts/individual"),
  });

  const renderInfo = () => (
    <>
      {accountContainerContext.isIndividual &&
        (isAccountsIndividualAvailable ? (
          <IndividualAccountInfo changeExiteIdOpenedModal={changeExiteIdOpenedModal} />
        ) : (
          <h2>Доступ к разделу отсуствует</h2>
        ))}
      {!accountContainerContext.isIndividual && (
        <OrganizationAccountInfo
          changeAccountVersion={changeAccountVersion}
          changeAddressVersion={changeAddressVersion}
          changeEmailOpenedModal={changeEmailOpenedModal}
          changeOrganizationVersion={changeOrganizationVersion}
          // checkExiteId={checkExiteId}
          closeOrganizationVersion={closeOrganizationVersion}
          handleCloseEmailVersion={handleCloseEmailVersion}
          fetchSubscriberVersions={fetchSubscriberVersions}
          fetchEmailVersions={fetchEmailVersions}
          // startReprocess={startReprocess}
          fetchAccountSubscribers={fetchAccountSubscribers}
          handleCreateEmailVersion={handleCreateEmailVersion}
          closeAccountVersion={closeAccountVersion}
          handleCreateSubscriberVersion={handleCreateSubscriberVersion}
          handleCreateSubscriberVersionLoading={handleCreateSubscriberVersionLoading}
          getAccountVersions={getAccountVersions}
          closeAddressVersion={closeAddressVersion}
          getAccount={getAccount}
          fetchAddressVersions={fetchAddressVersions}
          getPropertyVersions={getPropertyVersions}
          // checkAndStartReprocess={checkAndStartReprocess}
          getAccountOrganizationVersions={getAccountOrganizationVersions}
          changeExiteIdOpenedModal={changeExiteIdOpenedModal}
          handleCloseSubscriberVersion={handleCloseSubscriberVersion}
        />
      )}
    </>
  );

  const renderCreateExiteIdModal = () => {
    const onFinish = ({ exiteId, date }) => {
      const value = {
        fromDate: toHttpFormatStartOfDay(date),
        externalId: exiteId,
        accountId,
        subscriberTypeId: 1,
      };
      createExiteId(
        value
        // , () => checkAndStartReprocess(exiteId, date)
      );
      setIsExiteIdModalOpened(false);
    };
    return (
      <ModalWindow
        title="Технический ID"
        submitTextButton="Сохранить"
        visible={isExiteIdModalOpened}
        handleCancel={changeExiteIdOpenedModal}
        handleReset={changeExiteIdOpenedModal}
        footer={false}
      >
        <Form
          form={exiteIdForm}
          initialValues={{
            exiteId: "",
            date: "",
          }}
          onFinish={onFinish}
        >
          <Row justify="space-around">
            <Form.Item
              name="exiteId"
              rules={[{ required: true, message: "Поле обязательно для заполнения" }]}
              className="form-item-required__hidden-error"
            >
              <Input style={{ width: "246px" }} />
            </Form.Item>
            <Form.Item
              name="date"
              rules={[{ required: true, message: "Поле обязательно для заполнения" }]}
              className="form-item-required__hidden-error"
            >
              <DatePicker
                placeholder="с"
                format={displayFormat}
                disabledDate={(cur) => cur < moment().startOf("month")}
              />
            </Form.Item>
          </Row>
          <Row justify="center" gutter={[8, 8]}>
            <Col>
              <Button key="back" onClick={changeExiteIdOpenedModal}>
                Отмена
              </Button>
            </Col>
            <Col>
              <Button key="submit" type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalWindow>
    );
  };

  const renderCreateEmailModal = () => {
    const onFinish = ({ email }) => {
      const value = [
        {
          fromDate: toHttpFormatStartOfDay(moment()),
          email,
        },
      ];
      createEmail(value);
      changeEmailOpenedModal();
    };
    return (
      <ModalWindow
        title="Электронная почта"
        submitTextButton="Сохранить"
        visible={isEmailModalOpened}
        handleCancel={changeEmailOpenedModal}
        handleReset={changeEmailOpenedModal}
        footer={false}
      >
        <Form
          initialValues={{
            email: "",
          }}
          onFinish={onFinish}
          form={emailForm}
        >
          <Row justify="space-around">
            <Form.Item
              name="email"
              rules={[{ required: true, type: "email", message: "Введите корректный e-mail" }]}
            >
              <Input allowClear style={{ width: "360px" }} />
            </Form.Item>
          </Row>
          <Row justify="center" gutter={[8, 8]}>
            <Col>
              <Button key="back" onClick={changeEmailOpenedModal}>
                Отмена
              </Button>
            </Col>
            <Col>
              <Button key="submit" type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalWindow>
    );
  };

  return (
    <div className="account-info">
      {renderInfo()}
      {renderCreateExiteIdModal()}
      {renderCreateEmailModal()}
    </div>
  );
}
